module.exports = __webpack_public_path__ + "static/media/Coles_Insurance_logo-horizonal-red-RGB.567f17ae.svg";